module.exports = __webpack_public_path__ + "static/media/OvalEnd.dd2f3176.png";